import {PRODUCTION, STAGING} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"

const redirectLogoutUrl = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return "https://admin.perkbox.com/welcome/login"
  } else if (env.ENVIRONMENT_NAME === STAGING) {
    return "https://admin.perkbox.net/welcome/login"
  }
  return "http://localhost:3000/welcome/login"
}

export const msalConfig = {
  auth: {
    clientId: "2e928ec1-9aab-404d-a8d5-1b177be736ed",
    authority: "https://login.microsoftonline.com/3d374719-8476-4939-b1c5-a64f7c30eb23",
    redirectUri: redirectLogoutUrl()
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    pollIntervalMilliseconds: 15,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          console.error(level, message)
        }
      }
    }
  }
}

export const loginRequest = {
  scopes: ["User.Read"]
}
